<template>
  <b-modal
    id="modal-add-edit-category"
    ref="modal-add-edit-category"
    :title="modalTitle+' Category'"
    :header-bg-variant="headerBgVariant"
    :header-text-variant="headerTextVariant"
    :body-bg-variant="bodyBgVariant"
    :body-text-variant="bodyTextVariant"
    :footer-bg-variant="footerBgVariant"
    :footer-text-variant="footerTextVariant"
    no-close-on-backdrop
    @ok="handleOk"
  >
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form @submit.stop.prevent="handleSubmit(routeApiCall)">
        <validation-provider
          name="Category Data"
          :rules="{ required: true, min: 3 }"
          v-slot="validationContext"
        >
          <b-form-group id="input-group" label="Category Name" label-for="category-name-input">
            <b-form-input
              type="text"
              class="form-control"
              id="category-name-input"
              name="category-name-input"
              placeholder="Enter name to be displayed"
              v-model="curCategory.name"
              :state="getValidationState(validationContext)"
              aria-describedby="input-1-live-feedback"
            ></b-form-input>

            <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
export default {
  name: "category-modal",

  data: function () {
    return {
      headerTextVariant: "light",
      bodyBgVariant: "light",
      bodyTextVariant: "dark",
      footerBgVariant: "info",
      footerTextVariant: "dark",
    };
  },

  computed: {
    curCategory() {
      return this.$store.state.currentCategory;
    },
    headerBgVariant() {
      return this.curCategory.id > -1 ? "success" : "primary";
    },
    modalTitle() {
      return this.curCategory.id > -1 ? "Change" : "Add New";
    },
  },

  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.routeApiCall();
    },

    handleSubmit() {
      this.routeApiCall();
    },

    async routeApiCall() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$bvToast.toast(
          `Validation error. Fix the error before submission`,
          {
            title: "Error detected",
            variant: "warning",
            autoHideDelay: 5000,
          }
        );
        return;
      }

      if (this.curCategory.id > -1) {
        this.update();
      } else {
        this.create();
      }
    },

    async create() {
      this.$http
        .post(`${this.$API_URL}resource_categories/`, {
          name: this.curCategory.name,
          app: this.$store.state.currentAppId,
          owning_group: this.$store.state.currentGroupId,
          order: this.$store.state.currentCategoryCount,
        })
        .then((response) => {
          this.$bvToast.toast(
            `Category: ${response.data.name} successfully created!`,
            {
              title: "Successful Submission",
              variant: "success",
              autoHideDelay: 5000,
            }
          );

          this.$nextTick(() => {
            this.$bvModal.hide("modal-add-edit-category");
            this.resetModal();
          });
        })
        .catch((response) => {
          this.$bvToast.toast(
            `An ${response} has occured. An email has been sent to detailing the problem, but please try again!`,
            {
              title: "Error during submission",
              variant: "danger",
              autoHideDelay: 5000,
            }
          );
        });
    },

    async update() {
      this.$http
        .put(`${this.$API_URL}resource_categories/${this.curCategory.id}/`, {
          id: this.curCategory.id,
          name: this.curCategory.name,
          app: this.$store.state.currentAppId,
          owning_group: this.$store.state.currentGroupId,
          order: this.curCategory.order,
        })
        .then((response) => {
          this.$bvToast.toast(
            `Category: ${response.data.name} successfully updated!`,
            {
              title: "Successful Update",
              variant: "success",
              autoHideDelay: 5000,
            }
          );

          this.$nextTick(() => {
            this.$bvModal.hide("modal-add-edit-category");
            this.resetModal();
          });
        })
        .catch((response) => {
          this.$bvToast.toast(
            `An ${response} has occured. An email has been sent to detailing the problem, but please try again!`,
            {
              title: "Error during submission",
              variant: "danger",
              autoHideDelay: 5000,
            }
          );
        });
    },

    resetModal() {
      this.curCategory.name = "";
    },
  },
};
</script>